module.exports = __webpack_public_path__ + "img/team-member-04.d128eb4e.jpg";